/**
 * HQ 알림톡 사용료 청구 서비스. (대표 전용 — 백엔드에서 hq_admin 게이트)
 * 청구서는 매월 1일 09:10 스케줄러가 자동 생성한다.
 */
import hqApi from './hqApiClient';

export interface AlimtalkBill {
  organization_id: string;
  organization_name: string;
  year_month: string;
  sent_count: number;
  failed_count: number;
  by_type: Record<string, number>;
  unit_price: number;
  free_quota: number;
  billable_count: number;
  amount: number;
  status?: string; // unbilled | billed | paid | waived — 미리보기엔 없음
  paid_at?: string | null;
  paid_amount?: number | null;
  note?: string | null;
}

export interface AlimtalkBillList {
  year_month: string;
  saved: boolean; // false = 아직 청구서 생성 전(미리보기 숫자)
  unit_price_default: number;
  free_quota_default: number;
  total_sent: number;
  total_amount: number;
  unpaid_amount: number;
  bills: AlimtalkBill[];
}

export const hqAlimtalkBillService = {
  async list(month?: string, preview = false): Promise<AlimtalkBillList> {
    const { data } = await hqApi.get<AlimtalkBillList>('/api/v1/hq/alimtalk-bills', {
      params: { ...(month ? { month } : {}), ...(preview ? { preview: true } : {}) },
    });
    return data;
  },

  async generate(month?: string): Promise<any> {
    const { data } = await hqApi.post('/api/v1/hq/alimtalk-bills/generate', null, {
      params: month ? { month } : undefined,
    });
    return data;
  },

  async markPaid(organizationId: string, yearMonth: string, paidAmount?: number, note?: string) {
    const { data } = await hqApi.post(
      `/api/v1/hq/alimtalk-bills/${organizationId}/${yearMonth}/paid`,
      { paid_amount: paidAmount ?? null, note: note ?? null },
    );
    return data;
  },

  /**
   * 청구 안내 보내기 — 매장 문의창(💬 문의하기)에 안내문을 남기고 '입금 대기'로 바꾼다.
   * 안내문은 서버가 그 매장 청구서 값으로 직접 만든다(금액을 손으로 옮기지 않는다).
   */
  async notify(organizationId: string, yearMonth: string) {
    const { data } = await hqApi.post(
      `/api/v1/hq/alimtalk-bills/${organizationId}/${yearMonth}/notify`,
    );
    return data as {
      success: boolean;
      message: string;
      due_date: string | null;
      payment_account_missing: boolean;
    };
  },

  async markUnpaid(organizationId: string, yearMonth: string) {
    const { data } = await hqApi.post(
      `/api/v1/hq/alimtalk-bills/${organizationId}/${yearMonth}/unpaid`,
    );
    return data;
  },
};
